<template>
  <b-modal id="modal-scoped" size="lg" centered title="Create Strategic Demand">
    <template v-slot:default>
      <template v-if="!submittedSuccessfully">
        <b-form-group label="Product Key" label-for="productKey" label-cols="2" :state="errors.productKey && submitted || productKey.length < 1">
          <b-form-input
                  v-model="productKey"
                  id="productKey"
                  type="text"
                  required
                  placeholder="e.g. 004400"
                  :disabled="currentlySending"
          />
        </b-form-group>
        <b-form-group label="Variant Key" label-for="variantKey" label-cols="2" :state="errors.variantKey && submitted || variantKey.length < 1">
          <b-form-input
                  v-model="variantKey"
                  id="variantKey"
                  type="text"
                  required
                  placeholder="e.g. 004400"
                  :disabled="currentlySending"
          />
        </b-form-group>
        <b-form-group label="Amount" label-for="amount" label-cols="2" :state="errors.variantKey && submitted || amount.length < 1 ">
          <b-form-input
                  v-model="amount"
                  id="amount"
                  type="number"
                  required
                  placeholder="e.g. 004400"
                  :disabled="currentlySending"
          />
        </b-form-group>
        <b-form-group label="Diff Tax Possible" label-for="diffTaxPossible" label-cols="2" :state="errors.variantKey && submitted">
          <b-form-select
              v-model="diffTaxPossible"
              :options="diffTaxPossibleOptions"
              :disabled="currentlySending"
          ></b-form-select>
        </b-form-group>
      </template>
      <template v-else>
      <b-col cols="12" class="text-center">
        <b-alert variant="success">
          <b-iconstack scale="1.5">
            <b-icon stacked icon="circle-fill"></b-icon>
            <b-icon stacked icon="check" variant="white" scale="0.8"></b-icon>
          </b-iconstack>
          Successfully confirmed strategic demand<br /><br />
          <b-button variant="success" @click="$emit('cancel')">
            <b-icon-x/> Close
          </b-button>
        </b-alert>
      </b-col>
      </template>
      <template v-if="error.confirmStrategicDemand.isError">
        <b-alert variant="danger" v-model="error.confirmStrategicDemand.isError" class="mb-0">
          Something went wrong. If this problem persists, please contact the IT team. Add the following
          details to better pinpoint the problem:<br />
          Code:
          <strong>{{ error.confirmStrategicDemand.code }}</strong><br />
          Title:
          <strong>{{ error.confirmStrategicDemand.title }}</strong><br />
          Message:
          <strong>{{ error.confirmStrategicDemand.message }}</strong><br />
        </b-alert>
      </template>
    </template>
    <template v-slot:modal-footer="{ cancel }">
      <div v-if="!currentlySending" class="d-flex justify-content-between w-100">
        <b-button variant="danger"
                  class=""
                  @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="success"
                  class=""
                  @click="confirmStrategicDemand()">
          Confirm
        </b-button>
      </div>
      <div class="confirming-offer-div" v-if="currentlySending">
        Sending &nbsp; <b-spinner/>
      </div>
    </template>
  </b-modal>
  <!--<transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('cancel')">
        <div class="modal-container" @click.stop>
          <div class="modal-header d-sm-block d-none">
            <slot name="header"><h1>Create Strategic Demand</h1></slot>
          </div>

          <div class="d-sm-none">
            <b-button-close @click="$emit('cancel')"/>
            <h4>Create Strategic Demand</h4>
          </div>

          <div class="modal-body">
            <slot name="body">
              <b-row>
                <b-col v-if="!submittedSuccessfully">
                  <b-form-row>
                    <b-col cols="12" sm="2" class="col-form-key">Product Key</b-col>

                    <b-col cols="12" sm="10">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="productKey"
                          placeholder="e.g. 004400"
                          :disabled="currentlySending"
                          :class="{
                            'is-invalid': errors.productKey && submitted,
                          }"
                        />
                      </div>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col cols="12" sm="2" class="col-form-key">Variant Key</b-col>
                    <b-col cols="12" sm="10">
                      <div class="form-group has-error">
                        <input
                          type="text"
                          class="form-control"
                          v-model="variantKey"
                          placeholder="e.g. 004400"
                          :disabled="currentlySending"
                          :class="{
                            'is-invalid': errors.variantKey && submitted,
                          }"
                        />
                      </div>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col cols="12" sm="2" class="col-form-key">Amount</b-col>
                    <b-col cols="12" sm="4" class="align-content-end">
                      <input
                        type="number"
                        class="form-control text-right"
                        v-model="amount"
                        min="1"
                        :disabled="currentlySending"
                      />
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col>
                      <div v-if="!currentlySending">
                        <b-button variant="danger"
                          class=" btn-offer float-left"
                          @click="$emit('cancel')"
                        >
                          Cancel
                        </b-button>
                        <b-button variant="success"
                          class="btn-offer float-right"
                          @click="confirmStrategicDemand()"
                        >
                          Confirm
                        </b-button>
                      </div>
                      <div class="confirming-offer-div" v-if="currentlySending">
                        Sending &nbsp; <b-spinner/>
                      </div>
                    </b-col>
                  </b-form-row>
                </b-col>

                <b-col cols="12" v-else class="text-center">
                  <div class="alert alert-success alert-offer-value-success">
                    <b-iconstack scale="1.5">
                      <b-icon stacked icon="circle-fill"></b-icon>
                      <b-icon stacked icon="check" variant="white" scale="0.8"></b-icon>
                    </b-iconstack>
                    Successfully confirmed strategic demand<br /><br />
                    <b-button variant="success" @click="$emit('cancel')">
                      <b-icon-x/> Close
                    </b-button>
                  </div>
                </b-col>
                <b-col cols="12" v-if="error.confirmStrategicDemand.isError === true" class="text-left mt-3">
                  <div class="alert alert-danger" role="alert">
                    Something went wrong. If this problem persists, please contact the IT team. Add the following
                    details to better pinpoint the problem:<br />
                    Code:
                    <strong>{{ error.confirmStrategicDemand.code }}</strong
                    ><br />
                    Title:
                    <strong>{{ error.confirmStrategicDemand.title }}</strong
                    ><br />
                    Message:
                    <strong>{{ error.confirmStrategicDemand.message }}</strong
                    ><br />
                  </div>
                </b-col>
              </b-row>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>-->
</template>

<script>
import apiAuth from 'src/clients/apiAuth';
import constants from 'src/constants/constants';

export default {
  name: 'AdminStrategicDemandForm',
  data() {
    return {
      productKey: '',
      variantKey: '',
      amount: 1,
      diffTaxPossible: false,
      diffTaxPossibleOptions: [
        { value: false, text: 'No' },
        { value: true, text: 'Yes' },
      ],
      currentlySending: false,
      submitted: false,
      submittedSuccessfully: false,
      error: {
        confirmStrategicDemand: {
          isError: false,
          code: null,
          message: '',
        },
      },
      errors: {
        productKey: false,
        variantKey: false,
        amount: false,
      },
    };
  },
  methods: {
    resetError(errorKey) {
      this.error[errorKey].isError = false;
      this.error[errorKey].code = null;
      this.error[errorKey].title = '';
      this.error[errorKey].message = '';
    },
    setError(errorKey, code, title, message) {
      this.error[errorKey].isError = true;
      this.error[errorKey].code = code;
      this.error[errorKey].title = title;
      this.error[errorKey].message = message;
    },
    isValidOffer() {
      this.errors.amount = this.amount <= 0;
      this.errors.variantKey = this.variantKey.length <= 0;
      this.errors.productKey = this.productKey.length <= 0;

      return !(this.errors.productKey || this.errors.variantKey || this.errors.amount);
    },
    confirmStrategicDemand() {
      this.submitted = true;
      this.productKey = this.productKey.trim();
      this.variantKey = this.variantKey.trim();
      if (!this.isValidOffer()) {
        return false;
      }
      let options = {
        method: 'post',
        url: constants.url.demandService.baseUrl + constants.url.demandService.api.createStrategicDemand,
        data: {
          productKey: this.productKey,
          variantKey: this.variantKey,
          amount: this.amount,
          diffTaxPossible: this.diffTaxPossible
        },
      };
      this.currentlySending = true;
      this.resetError('confirmStrategicDemand');
      apiAuth(options)
        .then(() => {
          this.submittedSuccessfully = true;
          this.currentlySending = false;
          this.$emit('strategic-demand-created');
        })
        .catch((error) => {
          this.setError(
            'confirmStrategicDemand',
            error.response.status,
            error.response.data.errors[0].title,
            error.response.data.errors[0].message,
          );
          this.currentlySending = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.row-form {
  margin-bottom: 8px;
}
</style>
